'use client'

export default function MainLayout({ children }: { children: React.ReactNode }) {
  return <>{children}</>
}
